import { getTravels, getLimits, getAvailableDates, getAvailable, getCalc, getPayload, getCheck, getFinish } from '../lib/ApiServices'

import {updateValues} from './data'
import {showMessage, errorHome, errorLoad} from './messages'
import {ERROR_HOME} from './messages'

import es from './languages/es'
import fr from './languages/fr'

const initState = {
  tab: undefined,
  languages: {es: es, fr: fr},
  travels: [],
  promos: [],
  definedData: {
    passangers: [
      {name: 'adult', count: 'nAdults', defaultValues: { locationReturn: 0, locationGone: 0 } },
      {name: 'teen', count: 'nTeens', defaultValues: { locationReturn: 0, locationGone: 0 } },
      {name: 'kid', count: 'nKids', defaultValues: { locationReturn: 0, locationGone: 0 } },
      {name: 'baby', count: 'nBabies'},
    ],
    vehicles: [
      {name: 'car', title: 'Turismo', count: 'nCars', defaultValues: {} },
      {name: 'van', title: 'Furgoneta / Autocaravana', count: 'nVans', defaultValues: { length: 0 } },
      {name: 'motorcycle', title: 'Moto', count: 'nMotorcycles', defaultValues: {} },
      {name: 'towing', title: 'Remolque / Caravana', count: 'nTowing', defaultValues: { towing: 0 } },
    ],
  }
}

const ParseInt = (value) => (
  (value !== undefined)? parseInt(value, 0): 0
)

export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'
export const LOAD_TRAVELS = 'LOAD_TRAVELS'
export const LOAD_LIMITS = 'LOAD_LIMITS'
export const LOAD_AVAILABLEDATES = 'LOAD_AVAILABLEDATES'
export const LOAD_CALC = 'LOAD_CALC'
export const LOAD_AVAILABLECALCS = 'LOAD_AVAILABLECALCS'
export const LOAD_PAYMENT = 'LOAD_PAYMENT'
export const LOAD_CHECK = 'LOAD_CHECK'
export const LOAD_FINISH = 'LOAD_FINISH'
export const UNSET_TAB = 'LOAD_FINISH'

export const updateSettings = (val) => ({type: UPDATE_SETTINGS, payload: val})
export const loadTravels = (travels) => ({type: LOAD_TRAVELS, payload: travels})
export const loadLimits = (limits) => ({type: LOAD_LIMITS, payload: limits})
export const loadAvailableDates = (objects) => ({type: LOAD_AVAILABLEDATES, payload: objects})
export const loadCalc = (pricesD, pricesR) => ({type: LOAD_CALC, payloadA: pricesD, payloadB: pricesR})
export const LoadAvailableCalcs = (travels, pricesD, pricesR, promos) => ({type: LOAD_AVAILABLECALCS, payloadA: travels,  payloadB: pricesD,  payloadC: pricesR, promos})
export const loadPayment = (val) => ({type: LOAD_PAYMENT, payload: val})
export const loadCheck = (val) => ({type: LOAD_CHECK, payload: val})
export const loadFinish = (val) => ({type: LOAD_FINISH, payload: val})
export const doUnsetTab = () => ({type: UNSET_TAB})

export const fetchTravels = () => {
	return (dispatch) => {
		//dispatch(showMessage('Loading Todos'))
    const error = "Error cargando 'travels'"
		getTravels().then(travels => IsErrorMessage(dispatch, loadTravels, travels, error))
	}
}

export const fetchLimits = () => {
	return (dispatch) => {
		//dispatch(showMessage('Loading Todos'))
    const error ="Error cargando 'Limits'"
		getLimits().then(limits => IsErrorMessage(dispatch, loadLimits, limits, error))
	}
}

export const fetchAvailableDates = (values, settings) => {
	return (dispatch) => {
		//dispatch(showMessage('Cargando datos...'))
    const error ="Error cargando 'AvailableDates'"
		getAvailableDates(values, settings).then(dates => IsErrorMessage(dispatch, loadAvailableDates, dates, error))
	}
}

export const fetchCalc = (data, settings) => {
  const {departures, returns} = settings.available
  const {departuretravel, returntravel} = data.values
  let calcDeparture, calcReturn  = undefined

	return (dispatch) => {

		dispatch(showMessage('Calculando datos...'))

    //Get one way prices from the endpoint
    const travelD = departures[ParseInt(departuretravel)]._id
    getCalc(travelD, 0, data, settings).then(calcD => {
      let {message} = calcD
      if (message === undefined){
        if (calcReturn !== undefined | data.values.travel === 1){
          return (dispatch(loadCalc(calcD, calcReturn)))
        } else {
          calcDeparture = calcD
        }
      } else {
        return (dispatch(errorLoad(message)))
      }
    })

    //Get the prices back from the endpoint
    if (data.values.travel === 0){
      const travelR = returns[ParseInt(returntravel)]._id
      getCalc(travelR, 1, data, settings).then(calcR => {
        let {message} = calcR
        if (message === undefined){
          if (calcDeparture !== undefined){
            return (dispatch(loadCalc(calcDeparture, calcR)))
          } else {
            calcReturn = calcR
          }
        } else {
          return (dispatch(errorLoad(message)))
        }
      })
    }
	}
}

export const fetchAvailableCalcs = (data, settings) => {
  return (dispatch) => {
    const error ="Error cargando datos, vuelva a intentarlo!"
		dispatch(showMessage('Cargando datos...'))

		getAvailable(data, settings).then(travels => {
      let {message} = travels

      if (message === undefined){
        const {departures, returns, promos} = travels
        const {departuretravel, returntravel} = data.values
        let calcDeparture, calcReturn  = undefined
        let dataValues = {}

        if (departures !== undefined){
          if (departures.length === 1) dataValues['departuretravel'] = ParseInt(departuretravel)
        }

        //Get one way prices from the endpoint
        const travelD = departures[0]._id
        getCalc(travelD, 0, data, settings).then(calcD => {
          let {message} = calcD
          if (message === undefined){
            if (calcReturn !== undefined | data.values.travel === 1){
              dispatch(updateValues(dataValues))
              return (dispatch(LoadAvailableCalcs(travels, calcD, calcReturn, promos)))
            } else {
              calcDeparture = calcD
            }
          } else {
            return (dispatch(errorHome(message)))
          }
        })

        //Get the prices back from the endpoint
        if (data.values.travel === 0){
          if (returns !== undefined){
            if (returns.length === 1) dataValues['returntravel'] = ParseInt(returntravel)
          }

          const travelR = returns[0]._id
          getCalc(travelR, 1, data, settings).then(calcR => {
            let {message} = calcR
            if (message === undefined){
              if (calcDeparture !== undefined){
                dispatch(updateValues(dataValues))
                return (dispatch(LoadAvailableCalcs(travels, calcDeparture, calcR, promos)))
              } else {
                calcReturn = calcR
              }
            } else {
              return (dispatch(errorHome(message)))
            }
          })
        }
      } else {
        return (dispatch(errorHome(error)))
      }
    })
  }
}

export const fetchPayment = (settings, data, lang) => {
  console.log(settings, data, lang)
	return (dispatch) => {
		dispatch(showMessage('Se ha enviado la solicitud de pago...'))
    const error ="Error en Payment"
    getPayload(settings, data, lang).then(res => IsErrorMessage(dispatch, loadPayment, res, error))
	}
}

export const fetchCheck = (reference) => {
	return (dispatch) => {
		//dispatch(showMessage('Loading Todos'))
    const error ="Error 'Check'"
		getCheck(reference).then(res => IsErrorMessage(dispatch, loadCheck, res, error))
    .then(res => console.log(res.payload))
	}
}

export const fetchFinish = (settings, data) => {
	return (dispatch) => {
		//dispatch(showMessage('Loading Todos'))
    const error ="Error 'Finish'"
		getFinish(settings, data).then(res => IsErrorMessage(dispatch, loadFinish, res, error))
    .then(res => console.log(res.payload))
	}
}

export const askUnsetTab = (settings) => {
	return (dispatch) => {
		dispatch(doUnsetTab());
	}
}

//IsErrorMessage(dispatch, loadAvailable, travels, error)
const IsErrorMessage = (dispatch, fn, value, error) => {
  const {message} = value
  if (message === undefined){
    return (dispatch(fn(value)))
  } else {
    return (dispatch(errorLoad(error + ', ' + message)))
  }
}

export default (state = initState, action) => {
	switch (action.type){
		case UPDATE_SETTINGS:
	      return {...state, ...action.payload}
    case LOAD_TRAVELS:
      return {...state, travels: action.payload}
    case LOAD_LIMITS:
      return {...state, limits: action.payload}
    case LOAD_AVAILABLEDATES:
      return {...state, availabledates: action.payload}
    case LOAD_CALC:
      return {...state, calcDeparture: action.payloadA, calcReturn: action.payloadB}
    case LOAD_AVAILABLECALCS:
      return {...state, available: action.payloadA, calcDeparture: action.payloadB, calcReturn: action.payloadC, promos: action.promos}
    case ERROR_HOME:
      return {...state, tab: undefined}
    case UNSET_TAB:
      return {...state, tab: undefined}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/shared/routers/settings.js